var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInspection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 59,
    viewBox: "0 0 60 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 59,
    rx: 12,
    fill: "#FF7571"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5007 44.0833C31.1048 44.0833 32.4173 42.7708 32.4173 41.1666H26.584C26.584 42.7708 27.8819 44.0833 29.5007 44.0833ZM38.2507 35.3333V28.0416C38.2507 23.5646 35.859 19.8166 31.6882 18.825V17.8333C31.6882 16.6229 30.7111 15.6458 29.5007 15.6458C28.2902 15.6458 27.3132 16.6229 27.3132 17.8333V18.825C23.1277 19.8166 20.7507 23.55 20.7507 28.0416V35.3333L17.834 38.25V39.7083H41.1673V38.25L38.2507 35.3333Z",
    fill: "#FF423C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspection);
export default __webpack_public_path__ + "static/media/inspection.2c5ddecc267f8716e1288dfb9b593040.svg";
export { ForwardRef as ReactComponent };